import classNames from 'classnames'
import { Tags } from 'components/Tags'
import { Badge } from 'components/ui/Badge/Badge'
import { Button } from 'components/ui/Button/Button'
import { ReactNode, useCallback } from 'react'
import { Cargo, Container, Item } from 'services/warehouse-containers/containers'

export type Props = {
  element: Cargo
  onSubmut: (cargo: Cargo) => void
  buttonText?: string
}

export const CargoItem = ({ element, onSubmut, buttonText = 'Переместить' }: Props) => {
  const storekeeperComment = useCallback(() => {
    if (!element?.comments?.storekeeperComment) return null

    return (
      <div className="transfer-page-list-item__comment divider">
        <div className="hint">Комментарий к грузу:</div>
        <span>{element.comments.storekeeperComment}</span>
      </div>
    )
  }, [element?.comments?.storekeeperComment])

  const supportComment = useCallback(() => {
    if (!element?.comments?.supportComment) return null

    return (
      <div className="transfer-page-list-item__comment divider">
        <div className="hint">Дополнительный комментарий:</div>
        <span>{element.comments.supportComment}</span>
      </div>
    )
  }, [element?.comments?.supportComment])

  const containerItem = useCallback((el: Container, index: number) => {
    let badge: ReactNode

    if (el.status === 'empty') {
      badge = <Badge text="Выдан" badgeStyle="grey" />
    }

    if (el.sealNumber !== '') {
      badge = <Badge text={`№${el.sealNumber}`} badgeStyle="success"></Badge>
    }

    const textClass = classNames('transfer-page-list-item__body-containers-text', {
      hint: el.status === 'empty',
    })

    return (
      <li key={index}>
        {badge}
        <span className={textClass}>{el.name}</span>
      </li>
    )
  }, [])

  const cargoItems = useCallback(() => {
    if (!element?.items?.length) return null

    const items = [...element.items]
      .sort((a: Item, b: Item) => a.name.length - b.name.length)
      .map((el: Item, index: number) => (
        <Badge key={index} text={`${el.name} x${el.count}`} badgeStyle="grey"></Badge>
      ))

    return (
      <div className="transfer-page-list-item__body-items">
        <div>
          <span className="hint">Перевозка:</span>
        </div>
        <div className="flex-wrap">{items}</div>
      </div>
    )
  }, [element])

  const handleOnSubmit = () => {
    onSubmut?.(element)
  }

  return (
    <div className="transfer-page-list-item">
      <div className="transfer-page-list-item__header divider">
        <div>
          <h2 className="transfer-page-list-item__header-title">#{element.orderNumber}</h2>
          {element.product ? <Badge text={element.product} badgeStyle="default" /> : null}
        </div>
        <div className="transfer-page-list-item__header-tags">
          <Tags tags={element?.tags}></Tags>
        </div>
      </div>
      {storekeeperComment()}
      {supportComment()}
      <div className="transfer-page-list-item__body">
        <div className="transfer-page-list-item__body-containers">
          <ul>{element?.containers?.map(containerItem)}</ul>
        </div>
        {cargoItems()}
      </div>
      <div className="transfer-page-list-item__footer">
        <Button title={buttonText} handleOnSubmit={handleOnSubmit}></Button>
      </div>
    </div>
  )
}
